import { useState } from "react";
import { logoUrl } from "@/api/branding";
import { ImageTile, PlatformNavMark } from "@/components/brand/PlatformLogo";
import { usePlatformBrand } from "@/hooks/usePlatformBranding";
import { useTenantBranding } from "@/hooks/useTenantBranding";

/**
 * The workspace's own logo where it has one, ORAI's logo otherwise.
 *
 * Falls back to ORAI's logo -- or its icon, or the built-in mark, whichever the platform admin
 * has uploaded -- on EVERY path
 * that is not a loaded tenant logo -- still fetching, branding not granted, no logo uploaded, or
 * an image that fails to load -- so a broken or revoked logo never leaves an empty box.
 */
export function BrandMark({ size = 32 }: { size?: number }) {
  const { data } = useTenantBranding();
  const platform = usePlatformBrand();
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const src = logoUrl(data?.logo_path);

  if (!src || failedSrc === src) return <PlatformNavMark height={size} />;
  return (
    <ImageTile
      src={src}
      size={size}
      alt={data?.custom_brand_name ?? platform.brand_name}
      onError={() => setFailedSrc(src)}
    />
  );
}
